import { Injectable } from '@angular/core';
import { PushNotifications, Token } from '@capacitor/push-notifications';
import { Action, NgxsAfterBootstrap, Selector, State, StateContext, Store } from '@ngxs/store';
import { from, of, switchMap } from 'rxjs';
import { AppFeaturesState } from '../portal/app-feature.state';
import { ResetState } from '../shared';
import { FirebaseService } from './firebase.service';
import { LocalNotifications } from '@capacitor/local-notifications';

interface FirebaseStateModel {
	deviceToken: string | undefined;
	notificationsEnabled: boolean;
	localNotificationsEnabled: boolean;
}

@State<FirebaseStateModel>({
	name: 'firebaseState',
	defaults: {
		deviceToken: undefined,
		notificationsEnabled: false,
		localNotificationsEnabled: false,
	},
})
@Injectable()
export class FirebaseState implements NgxsAfterBootstrap {
	constructor(private firebaseService: FirebaseService, private appFeaturesState: AppFeaturesState, private store: Store) {}

	@Selector()
	static deviceToken(state: FirebaseStateModel) {
		return state.deviceToken;
	}

	get deviceToken() {
		return this.store.selectSnapshot(FirebaseState.deviceToken);
	}

	ngxsAfterBootstrap(ctx?: StateContext<FirebaseStateModel> | undefined): void {
		const isApp = this.appFeaturesState.isNativeIos || this.appFeaturesState.isNativeAndroid;
		if (!isApp) {
			// this.firebaseService
			//   .requestPermission()
			//   .pipe(
			//     tap((deviceToken) => {
			//       if (ctx) {
			//         ctx.patchState({ deviceToken });
			//         this.firebaseService.listen();
			//       }
			//     })
			//   )
			//   .subscribe();
		} else {
			PushNotifications.addListener('registration', (token: Token) => {
				console.log('Push registration success, token: ' + token.value);
				ctx?.patchState({ deviceToken: token.value });
			});
			const permissionStatus$ = from(PushNotifications.requestPermissions());
			permissionStatus$
				.pipe(
					switchMap((pushNotificationPermissionState) => {
						ctx?.patchState({ notificationsEnabled: pushNotificationPermissionState.receive === 'granted' });
						if (pushNotificationPermissionState.receive !== 'granted') {
							console.log('notificationState', pushNotificationPermissionState.receive);
							return of(undefined);
						}
						return from(PushNotifications.register());
					})
				)
				.subscribe((res) => {
					console.log('Firebas result', res);
				});
			const localPermissionStatus$ = from(LocalNotifications.requestPermissions());
			localPermissionStatus$
				.pipe(
					switchMap((localNotificationPermissionState) => {
						ctx?.patchState({ localNotificationsEnabled: localNotificationPermissionState.display === 'granted' });
						if (localNotificationPermissionState.display !== 'granted') {
							console.log('localNotificationState', localNotificationPermissionState.display);
							return of(undefined);
						}
						return of();
					})
				)
				.subscribe();
		}
	}

	@Action(ResetState)
	resetState(ctx: StateContext<FirebaseStateModel>) {
		ctx.setState({
			deviceToken: this.deviceToken,
			notificationsEnabled: false,
			localNotificationsEnabled: false,
		});
	}
}
